import { Product } from 'models';
import { ProductAnalyticsMicroMessageContent } from 'models/analytics';

function getProductAnalyticsMicroMessage(product: Product) {
  const messageContent: ProductAnalyticsMicroMessageContent = {
    productName: `${product.name}`,
  };

  return {
    schemaName: 'affiliateHubProduct',
    messageContent,
  };
}

export { getProductAnalyticsMicroMessage };
